<div class="auth-container">
  <div class="auth-background">
    <div class="gradient-orb gradient-orb-1"></div>
    <div class="gradient-orb gradient-orb-2"></div>
  </div>

  <div class="auth-content">
    <div class="auth-card">
      <!-- Top bar: Brand + Theme-Toggle -->
      <div class="desk-top">
        <div class="fp-brand">
          <img
            src="../../../../../assets/img/logo-text.svg"
            alt="FixPlaner"
            class="logo"
          />
        </div>
        <div class="auth-top-actions">
          <xds-icon-button
            [icon]="'fa-light ' + getThemeIconClass()"
            [ariaLabel]="'REG_THEME_TOGGLE_LABEL' | translate"
            (clicked)="toggleTheme()"
          ></xds-icon-button>
        </div>
      </div>

      <!-- Status Icon (groß, zentriert, je nach Status) -->
      <div
        class="status-icon"
        [class.success]="isSuccess"
        [class.error]="errorStatus.showError"
        [class.info]="isAlreadyConfirmed"
        [class.loading]="isLoading()"
      >
        <i
          class="fa-light"
          [class.fa-check]="isSuccess"
          [class.fa-xmark]="errorStatus.showError"
          [class.fa-circle-info]="isAlreadyConfirmed"
          [class.fa-spinner-third]="isLoading()"
        ></i>
      </div>

      <!-- Greeting — Status-Page: nur H1, kein Lede (würde H1 wiederholen) -->
      <div class="desk-greet" style="text-align:center">
        <h1 *ngIf="message">
          <span class="grad" *ngIf="isSuccess">{{ message }}</span>
          <span *ngIf="!isSuccess">{{ message }}</span>
        </h1>
      </div>

      <!-- Error Alert -->
      <xds-banner *ngIf="errorStatus.showError" variant="danger">{{ errorStatus.errorMessage }}</xds-banner>

      <!-- Konto war bereits bestätigt: kein Fehler, nur ein Hinweis mit dem Weg nach vorn -->
      <xds-banner *ngIf="isAlreadyConfirmed" variant="info">{{ hint }}</xds-banner>

      <!-- Action Buttons -->
      <div class="desk-actions" style="justify-content: center">
        <ng-container *ngIf="(isSuccess || isAlreadyConfirmed) && !isLoading()">
          <xds-button
            variant="primary"
            iconRight="fa-light fa-arrow-right"
            (clicked)="navigateTo('/login')"
          >
            {{ "PROCEED_TO_LOGIN" | translate }}
          </xds-button>
        </ng-container>

        <ng-container *ngIf="errorStatus.showError">
          <xds-button
            variant="primary"
            iconLeft="fa-light fa-house"
            (clicked)="navigateTo('/dashboard')"
          >
            {{ "RETURN_TO_DASHBOARD" | translate }}
          </xds-button>
          <p class="helper" style="text-align:center">
            <a (click)="navigateTo('/login')" style="cursor:pointer">
              <i class="fa-light fa-arrow-right-to-bracket"></i>
              {{ "RETURN_TO_LOGIN" | translate }}
            </a>
          </p>
        </ng-container>
      </div>
    </div>
  </div>
</div>
